import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateStartTimeSmartScheduleShift", function updateStartTimeSmartScheduleShift(newTime: Moment) {
    if (shiftEditorViewState().smartScheduleShift && newTime) {
        shiftEditorViewState().smartScheduleShift.startTime = newTime.clone();
    }
});